const DCS = {
  EU_WEST_1: 0,
  EU_CENTRAL_1: 1,
  AP_SOUTHEAST_1: 2,
  AP_NORTHEAST_1: 3,
  UK1: 64,
  UK2: 65,
  NL1: 66,
  SG1: 67,
  HK1: 68,
};

const PRECISION = {
  MILLI: 0,
  SECOND: 1,
  DAY: 2,
  WEEK: 4,
  MONTH: 5,
  YEAR: 6,
  ANYTIME: 7,
  MINUTE: 8,
};

export { DCS, PRECISION };
